export default "__VITE_ASSET__9fs1DCSU__"